import { render, staticRenderFns } from "./pro.vue?vue&type=template&id=6fd0c34c&scoped=true&"
import script from "./pro.vue?vue&type=script&lang=js&"
export * from "./pro.vue?vue&type=script&lang=js&"
import style0 from "./pro.vue?vue&type=style&index=0&id=6fd0c34c&lang=scss&scoped=true&"
import style1 from "./pro.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd0c34c",
  null
  
)

component.options.__file = "pro.vue"
export default component.exports